import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import "./styles.less";

export const SolutionSceneIntro = (props) => {
  const { t } = useTranslation();

  const { scene } = props;
  return (
    <>
      <div className="solution-scene-intro">
        <div className="solution-scene-intro-card">
          <div className="content-warp">
            <div className="title">{t("solution.scene.title-intro")}</div>
            <div className="descript">{scene}</div>
          </div>
        </div>
      </div>
    </>
  );
};
